import { render, staticRenderFns } from "./avoidLogin.vue?vue&type=template&id=c949c7e4"
import script from "./avoidLogin.vue?vue&type=script&lang=js"
export * from "./avoidLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports